import { championSeeds, stagePills } from "@/mocks/chigua";

const seedInfo: Record<string, { region: string; desc: string; ring: string }> = {
  瓜小满: { region: "上半区", desc: "A 组头名 · 本赛季头号种子", ring: "bg-primary-100 text-primary-700" },
  月半瓜: { region: "上半区", desc: "B 组头名 · 人气黑马", ring: "bg-accent-100 text-accent-700" },
  黑籽侦探: { region: "下半区", desc: "C 组头名 · 技术型瓜位", ring: "bg-background-200 text-foreground-700" },
  滚圆球球: { region: "下半区", desc: "D 组头名 · 后半程发力", ring: "bg-secondary-100 text-secondary-700" },
};

const reachedStage = 3; // 已完成到 4 强

export default function Bracket() {
  return (
    <section id="bracket" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-1.5 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-sm font-bold uppercase tracking-wide text-accent-600">晋级名单 Standings</p>
            <h2 className="mt-2 font-heading text-3xl leading-tight text-foreground-950 md:text-4xl">
              谁在晋级，谁在等你下注
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-600">
            本赛季 64 位候选瓜位经过层层对抗，现已决出四强。晋级名单随每轮战果实时刷新。
          </p>
        </div>

        {/* stage stepper */}
        <ol className="mt-9 flex flex-wrap items-center gap-y-3 overflow-hidden rounded-3xl bg-background-100 px-4 py-4 md:px-6">
          {stagePills.map((s, i) => {
            const done = i <= reachedStage;
            const current = i === reachedStage;
            return (
              <li key={s} className="flex flex-1 items-center">
                <div className="flex items-center gap-2">
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-bold ${
                      current
                        ? "bg-primary-500 text-background-50"
                        : done
                          ? "bg-accent-500 text-background-50"
                          : "bg-background-200 text-foreground-500"
                    }`}
                  >
                    {done ? <i className="ri-check-line text-xs" aria-hidden="true"></i> : i + 1}
                  </span>
                  <span
                    className={`whitespace-nowrap text-xs font-semibold ${
                      done ? "text-foreground-800" : "text-foreground-400"
                    }`}
                  >
                    {s}
                  </span>
                </div>
                {i < stagePills.length - 1 && (
                  <span
                    className={`mx-3 h-0.5 flex-1 rounded-full ${
                      i < reachedStage ? "bg-accent-400" : "bg-background-200"
                    }`}
                  ></span>
                )}
              </li>
            );
          })}
        </ol>

        {/* four seeds */}
        <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {championSeeds.map((name, idx) => {
            const info = seedInfo[name];
            return (
              <article
                key={name}
                className="relative overflow-hidden rounded-3xl border border-background-200 bg-background-50 p-5"
              >
                <span className="absolute right-4 top-4 font-heading text-4xl text-background-100">
                  {String(idx + 1).padStart(2, "0")}
                </span>
                <div className="flex items-center gap-3">
                  <span className={`flex h-12 w-12 items-center justify-center rounded-2xl font-heading text-xl ${info.ring}`}>
                    {name.slice(0, 1)}
                  </span>
                  <div>
                    <h3 className="font-heading text-lg leading-none text-foreground-950">{name}</h3>
                    <p className="mt-1 text-[11px] text-foreground-500">{info.region}</p>
                  </div>
                </div>
                <p className="mt-3 text-xs leading-relaxed text-foreground-600">{info.desc}</p>
                <div className="mt-4 flex items-center justify-between text-xs">
                  <span className="inline-flex items-center gap-1 font-semibold text-accent-700">
                    <i className="ri-checkbox-circle-fill text-accent-500" aria-hidden="true"></i>
                    已晋级 · 半决赛
                  </span>
                  <a href="#schedule" className="font-semibold text-primary-600 hover:text-primary-700">
                    看对阵 <i className="ri-arrow-right-line text-xs" aria-hidden="true"></i>
                  </a>
                </div>
              </article>
            );
          })}
        </div>

        <div className="mt-6 flex flex-col items-start gap-3 rounded-3xl bg-primary-100/70 p-5 md:flex-row md:items-center md:justify-between md:px-6">
          <div className="flex items-start gap-3">
            <span className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-primary-500 text-background-50">
              <i className="ri-vip-crown-2-line text-lg" aria-hidden="true"></i>
            </span>
            <p className="text-sm leading-relaxed text-foreground-700">
              <strong className="font-bold text-foreground-900">下一步看点：</strong>
              今晚半决赛决出两个决赛席位，9·12 总决赛之夜将加冕 S07 赛季瓜王。被淘汰瓜位仍可凭“复活榜”人气重返舞台。
            </p>
          </div>
          <a
            href="#live"
            className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
          >
            追实时动态 <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </section>
  );
}